import React from "react";
import { Checkbox, notification } from "antd";
import RequestHandler from "../../../../util/RequestHandler";

const ContactCell = (props) => {
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Hesap yetkilendirme işlemi başarılı!',
      duration: 2,
    });
  };

  const onContactSelect = (value) => {
    RequestHandler.post(`/TenantAccount/AddTenantAccountUser`, {
      tenantAccountId: value,
      tenantId: localStorage.getItem("tenantId"),
      userId: props.userId
    }, false, { rawResponse: true }).then(response => {
      if (response.status == 200) {
        openNotificationWithIcon('success');
        props.sendDataForUpdate(bankId);
      }
    });
  };

  const { contact } = props;
  const { iban, accountNumber, isAccountChecked, bankId, id, bankName, currency, branchName } = contact;
  return (

    <div className="gx-contact-item">
      <div className="gx-module-list-icon">
        <Checkbox className="gx-icon-btn"
          checked={isAccountChecked}
          value="checkedF"
          onClick={() => onContactSelect(id)} />
        <div className="gx-d-none gx-d-sm-flex" >
        </div>
        <div className="gx-ml-2 gx-d-none gx-d-sm-flex">
        </div>
      </div>

      <div className="gx-module-list-info gx-contact-list-info">
        <div className="gx-module-contact-content">
          <p className="gx-mb-1">
            <span className="gx-text-truncate gx-contact-name"> {iban === null ? (accountNumber === null ? bankName : accountNumber) : iban} </span>
            <span className="gx-toolbar-separator">&nbsp;</span>
            <span className="gx-text-truncate gx-job-title"></span>
          </p>
          <div className="gx-text-muted">
            <span className="gx-email gx-d-inline-block gx-mr-2">
              {branchName === null ? "" : branchName + ","}
            </span>
            <span className="gx-phone gx-d-inline-block">{currency}</span>
          </div>
        </div>

        <div className="gx-module-contact-right">

        </div>
      </div>
    </div>
  )
}

export default ContactCell;
